import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiParcelChargesGet } from '@/entities/charges/modules/api/charges';

export const useParcelCharges = (parcelId: string | undefined) =>
  useFetch({
    api: () => apiParcelChargesGet(parcelId ?? ''),
    keywords: queryKeys.parcels.charges(parcelId ?? ''),
    enabled: Boolean(parcelId),
    staleTime: 30_000,
  });
